import { createRef, useEffect } from "react";
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { postGoogleAuth } from "@api";
import {
  get_google_public_oauth_url,
  recoverBrowserSecurityError,
} from "@utils";

const ACCESS_TOKEN_KEY = "access_token";
const LAST_LOGIN_AT_KEY = "last_login_at";
const EXPIRES_AT_KEY = "expires_at";

const ButtonContainer = styled.div`
  width: 400px;
  height: 40px;
  display: flex;
  border-radius: 4px;
  background: white; // Black compatible with google's black
`;

/*
    Display the Google sign in button. It's somewhat complex to create,
    as it uses Google magic to render and use.

    Find more information (where some parts of the implementation come from) at:
    https://github.com/anthonyjgrove/react-google-login/issues/502
*/
export const GoogleLogin = () => {
  const googleSignInButton = createRef<HTMLDivElement>();
  const history = useHistory();

  useEffect(() => {
    if (!googleSignInButton?.current || !window.google) return;

    const responseGoogle = async (response: any) => {
      // TODO: Make better
      const token = await postGoogleAuth(response.credential);

      // save bearer token from backend to localStorage
      const decodedSemgrepToken = jwt_decode<any>(token);
      recoverBrowserSecurityError(() => {
        localStorage.setItem(ACCESS_TOKEN_KEY, token);
        localStorage.setItem(
          LAST_LOGIN_AT_KEY,
          new Date().getTime().toString()
        );
        localStorage.setItem(
          EXPIRES_AT_KEY,
          JSON.stringify(decodedSemgrepToken.exp * 1000)
        );
      });
      // Need to fully refresh the page to get all auth info
      // nosemgrep
      window.location.href = "/orgs/-/";
    };

    window.google.accounts.id.initialize({
      client_id: get_google_public_oauth_url(),
      callback: responseGoogle,
    });

    const buttonCustomization: GsiButtonConfiguration = {
      type: "standard",
      theme: "outline",
      size: "large",
      text: "signin_with",
      width: "400px",
      shape: "square",
      logo_alignment: "center",
    };

    window.google.accounts.id.renderButton(
      googleSignInButton.current,
      buttonCustomization
    );
  }, [googleSignInButton, history]);

  return <ButtonContainer ref={googleSignInButton}></ButtonContainer>;
};
